import Immutable from 'immutable';

import reducerCreator from '../../../../tools/reducer-creator';
import * as types from '../../../../actions/admin/users/candidates/types';

const initialState = Immutable.fromJS({
  isLoading: false,
  candidateProfileDetailsBiographicalInfo: null,
  candidateProfileDetailsContactInfo: null,
  candidateProfileDetailsHealth: null,
  candidateProfileDetailsHousingPreferences: null,
  candidateProfileDetailsLanguages: null,
  candidateProfileDetailsPersonal: null,
  candidateProfileDetailsSecondarySchools: null,
  candidateProfileDetailsSportsActivities: null,
  candidateProfileDetailsTeachingExperience: null,
  candidateProfileDetailsTeachingCredentials: null,
  candidateProfileDetailsUnivesitiesColleges: null,
  printVersionIsLoading: false,
});

export default reducerCreator(initialState, {
  [types.ADMIN_USERS_CANDIDATE_SET_PROFILE_LOADING]: (state, { isLoading }) =>
    state.set('isLoading', isLoading),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION]: (
    state,
    { biographicalInfo }
  ) =>
    state.set(
      'candidateProfileDetailsBiographicalInfo',
      Immutable.fromJS(biographicalInfo)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION]: (
    state,
    { contactInfo }
  ) =>
    state.set(
      'candidateProfileDetailsContactInfo',
      Immutable.fromJS(contactInfo)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_HEALTH]: (state, { health }) =>
    state.set('candidateProfileDetailsHealth', Immutable.fromJS(health)),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES]: (
    state,
    { housingPreferences }
  ) =>
    state.set(
      'candidateProfileDetailsHousingPreferences',
      Immutable.fromJS(housingPreferences)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_LANGUAGES]: (state, { languages }) =>
    state.set('candidateProfileDetailsLanguages', Immutable.fromJS(languages)),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_PERSONAL]: (state, { personal }) =>
    state.set('candidateProfileDetailsPersonal', Immutable.fromJS(personal)),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS]: (
    state,
    { secondarySchools }
  ) =>
    state.set(
      'candidateProfileDetailsSecondarySchools',
      Immutable.fromJS(secondarySchools)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_SPORTS_ACTIVITIES]: (
    state,
    { sportsActivities }
  ) =>
    state.set(
      'candidateProfileDetailsSportsActivities',
      Immutable.fromJS(sportsActivities)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE]: (
    state,
    { teachingExperience }
  ) =>
    state.set(
      'candidateProfileDetailsTeachingExperience',
      Immutable.fromJS(teachingExperience)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS]: (
    state,
    { teachingCredentials }
  ) =>
    state.set(
      'candidateProfileDetailsTeachingCredentials',
      Immutable.fromJS(teachingCredentials)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES]: (
    state,
    { universitiesColleges }
  ) =>
    state.set(
      'candidateProfileDetailsUnivesitiesColleges',
      Immutable.fromJS(universitiesColleges)
    ),

  [types.ADMIN_USERS_CANDIDATE_PROFILE_PRINT_VERSION_IS_LOADING]: (
    state,
    { printVersionIsLoading }
  ) =>
    state.set(
      'printVersionIsLoading',
      printVersionIsLoading
    )
});



// WEBPACK FOOTER //
// ./src/reducers/admin/users/candidates/admin-users-candidate-profile.js